module.exports = __webpack_public_path__ + "static/media/boat-bottom.463a4cca.svg";